export default __webpack_public_path__ + "static/media/logo_kth.d98496eb.png";